import AiConfigPage from "../../modules/candidate-screening/ai-config.page";

export const allPermissions = {
    VIEW_CTC: 'global.view_ctc',

    //STAFF
    VIEW_STAFF: 'staff.view',
    CREATE_STAFF : 'staff.create',
    STAFF_BULK_UPLOAD : 'staff.bulk_create',
    UPDATE_STAFF: 'staff.update',
    DELETE_STAFF : 'staff.delete',
    STAFF_ACTIVITY_LOGS: 'staff.activity_logs',
    APPROVE_STAFF: 'staff.approve',
    REJECT_STAFF: 'staff.reject',
    FILE_UPLOAD_STAFF: 'staff.upload',

    //STAFF SALARY REVISION
    VIEW_STAFF_SALARY_REVISION: 'staff.view_salary_revision',
    CREATE_STAFF_SALARY_REVISION: 'staff.create_salary_revision',
    UPDATE_STAFF_SALARY_REVISION: 'staff.update_salary_revision',


    //PROJECT
    VIEW_PROJECT: 'project.view',
    CREATE_PROJECT : 'project.create',
    PROJECT_BULK_UPLOAD : 'project.bulk_create',
    UPDATE_PROJECT: 'project.update',
    DELETE_PROJECT : 'project.delete',
    PROJECT_ACTIVITY_LOGS: 'project.activity_logs',
    PROJECT_STAFF_ASSIGNMENT: 'project.view_staff_assignment',
    PROJECT_ADD_STAFF_ASSIGNMENT: 'project.create_staff_assignment',
    PROJECT_UPDATE_STAFF_ASSIGNMENT:'project.update_staff_assignment',
    VIEW_BILLING_SUMMARY: 'project.view_billing_summary',
    APPROVE_PROJECT: 'project.approve',
    REJECT_PROJECT: 'project.reject',


    //VENDOR
    VIEW_VENDOR: 'vendor.view',
    CREATE_VENDOR : 'vendor.create',
    UPDATE_VENDOR: 'vendor.update',
    DELETE_VENDOR : 'vendor.delete',
    VENDOR_ACTIVITY_LOGS: 'vendor.activity_logs',

    // ===== ACCOUNT =====
    VIEW_ACCOUNT: 'account.view',
    CREATE_ACCOUNT : 'account.create',
    UPDATE_ACCOUNT: 'account.update',
    DELETE_ACCOUNT : 'account.delete',
    ACCOUNT_ACTIVITY_LOGS: 'account.activity_logs',

    // ===== DEPARTMENT =====
    VIEW_DEPARTMENT: 'department.view',
    CREATE_DEPARTMENT : 'department.create',
    UPDATE_DEPARTMENT: 'department.update',
    DELETE_DEPARTMENT : 'department.delete',
    DEPARTMENT_ACTIVITY_LOGS: 'department.activity_logs',

    // ===== SUBDEPARTMENT =====
    VIEW_SUBDEPARTMENT: 'subdepartment.view',
    CREATE_SUBDEPARTMENT : 'subdepartment.create',
    UPDATE_SUBDEPARTMENT: 'subdepartment.update',
    DELETE_SUBDEPARTMENT : 'subdepartment.delete',
    SUBDEPARTMENT_ACTIVITY_LOGS: 'subdepartment.activity_logs',

    // ===== FOREX =====
    VIEW_FOREX: 'forex.view',
    CREATE_FOREX : 'forex.create',
    UPDATE_FOREX: 'forex.update',

    // ===== CANDIDATE SCREENING (plan.md §10) =====
    // Defined ahead of the app-wide PermissionsGuard so the module is ready to be
    // enforced the moment that guard lands; behaviour is unchanged until then.
    VIEW_JD_MASTER: 'jdMaster.view',
    JD_MASTER_CREATE: 'jdMaster.create',
    JD_MASTER_UPDATE: 'jdMaster.update',
    JD_MASTER_DELETE: 'jdMaster.delete',
    JD_MASTER_RESUME_UPLOAD: 'jdMaster.resume_upload',
    JD_MASTER_SCREENING_RUN: 'jdMaster.screening_run',
    JD_MASTER_RANK: 'jdMaster.rank',
    JD_MASTER_ACTIVITY_LOGS: 'jdMaster.activity_logs',
    JD_MASTER_BULK_CREATE: 'jdMaster.bulk_create',
    VIEW_RESUME_MASTER: 'resumeMaster.view',
    RESUME_UPLOAD: 'resumeMaster.upload',
    AICONFIG_VIEW: 'aiConfig.view',
    AICONFIG_CREATE: 'aiConfig.create',
    
    // ===== USER =====
    VIEW_USER: 'user.view',
    CREATE_USER: 'user.create',
    UPDATE_USER: 'user.update',
    DELETE_USER: 'user.delete',
    USER_ACTIVITY_LOGS: 'user.activity_logs',

    // ===== ROLE =====
    VIEW_ROLE: 'role.view',
    CREATE_ROLE: 'role.create',
    UPDATE_ROLE: 'role.update',
    DELETE_ROLE: 'role.delete',
    ROLE_ACTIVITY_LOGS: 'role.activity_logs',

    // ======= EMAIL =======
    VIEW_EMAIL: 'email.view',
    CREATE_EMAIL: 'email.create',
    UPDATE_EMAIL: 'email.update',
    DELETE_EMAIL: 'email.delete',
    EMAIL_ACTIVITY_LOGS: 'email.activity_logs',

    // ======= Dashboard =======
    VIEW_DASHBOARD: 'dashboard.view',
    VIEW_REPORT: 'report.view',
    REPORT_EXPORT: 'report.export',
     
//===== DOCUMENT MANAGEMENT =====
  CREATE_DOCUMENT_TYPE: "document_type.create",
  UPDATE_DOCUMENT_TYPE: "document_type.update",
  DELETE_DOCUMENT_TYPE: "document_type.delete",
  VIEW_DOCUMENT_TYPE: "document_type.view",
  DOCUMENT_TYPE_ACTIVITY_LOGS: "document_type.activity_logs",

  CREATE_DOCUMENT_SUB_TYPE: "document_sub_type.create",
  UPDATE_DOCUMENT_SUB_TYPE: "document_sub_type.update",
  DELETE_DOCUMENT_SUB_TYPE: "document_sub_type.delete",
  VIEW_DOCUMENT_SUB_TYPE: "document_sub_type.view",
  DOCUMENT_SUB_TYPE_ACTIVITY_LOGS: "document_sub_type.activity_logs",
};

  


